import React from "react";
import { Card, CardHeader, CardBody, Spinner } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { threatCard, threatCardHeader, threatCardBody, threatIconChip } from "./cardStyles";

const HourlyAlertDistribution = ({ data, loading }) => {
  if (loading) {
    return (
      <Card className="h-100" style={threatCard}>
        <CardHeader style={threatCardHeader}>
          <h5 className="card-title mb-0">Hourly Alert Distribution</h5>
        </CardHeader>
        <CardBody className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px", ...threatCardBody }}>
          <Spinner color="primary" />
        </CardBody>
      </Card>
    );
  }

  const chartData = data || [];
  
  const hourlyData = Array(24).fill(0);
  chartData.slice(0, 24).forEach((item, index) => {
    hourlyData[index] = item.value;
  });

  const options = {
    chart: {
      type: "line",
      toolbar: { show: false }
    },
    stroke: {
      curve: "smooth",
      width: 3
    },
    xaxis: {
      categories: Array.from({ length: 24 }, (_, i) => `${i}:00`),
      labels: {
        rotate: -45,
        style: {
          fontSize: "10px"
        }
      }
    },
    yaxis: {
      title: {
        text: "Alerts"
      }
    },
    colors: ["#FF5B00"],
    markers: {
      size: 4,
      colors: ["#FF5B00"],
      strokeColors: "#fff",
      strokeWidth: 2
    },
    grid: {
      borderColor: "#f1f5f9"
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} alerts`
      }
    }
  };

  const series = [{
    name: "Alerts",
    data: hourlyData
  }];

  return (
    <Card className="h-100" style={threatCard}>
      <CardHeader style={threatCardHeader}>
        <div className="d-flex align-items-center gap-3">
          <div style={threatIconChip()}>
            <i className="ri-time-line" style={{ color: "var(--vz-primary)", fontSize: 16 }}></i>
          </div>
          <h5 className="card-title mb-0">Hourly Alert Distribution</h5>
        </div>
      </CardHeader>
      <CardBody style={threatCardBody}>
        <ReactApexChart options={options} series={series} type="line" height={280} />
      </CardBody>
    </Card>
  );
};

export default HourlyAlertDistribution;
